export default __webpack_public_path__ + "assets/luxembourg-flag.png";